export const RESET_TIME = 'reset-timeout-time';
export const HAS_SIGNED_OUT = 'reset-timeout-has-timed-out';
